import React from "react";
import ProtectProductInfo from "components/Product-Info-Pages/Protect/ProtectProductInfo";

const Protect = () => <ProtectProductInfo />;

export default Protect;
